import {ReactElement} from 'react';
import {Stack} from '@mantine/core';
import {DataTableColumn} from 'mantine-datatable';

import {
    MantineDataTable,
    SimpleTableBatchAction,
} from '@flexinet/ui-components';

import {useTestingActions} from '../hooks/useTestingActions.ts';
import {useTestingActionsPaging} from '../hooks/useTestingActionsPaging.ts';
import {useTestingActionsSearch} from '../hooks/useTestingActionsSearch.ts';
import {useTestingActionsSelection} from '../hooks/useTestingActionsSelection.ts';
import {useVerifiedPermissions} from '../../../hooks/useVerifiedPermissions.ts';
import {rbacActions} from '../../../config/rbac/actions.ts';
import {TestingAction} from '../types.ts';

export const RecordsTable = ({
                                 extraTools,
                                 settings,
                             }: {
    extraTools?: ReactElement[],
    settings?: { label: string, onClick: () => void }[]
}) => {

    const {allowedActions} = useVerifiedPermissions();

    const {
        columns,
        visibleItems: records,
        loading,
    } = useTestingActions();

    const {
        page,
        limit,
        totalCount,
        handleItemsPerPageChange,
        handlePageChange,
    } = useTestingActionsPaging(records.length);

    // Same store instance the list hook filters on (FNP-815).
    const {handleFilterByKeyword} = useTestingActionsSearch();

    const {
        selection,
        handleRowSelection,
        handleClearSelection,
    } = useTestingActionsSelection();

    let selectedRecords: TestingAction[] = [];
    if (allowedActions.includes(rbacActions.DeleteTestingAction)) {
        selectedRecords = records.filter(record => selection[record.id] === true);
    }

    return (
        <Stack>
            <SimpleTableBatchAction
                limit={limit}
                handleItemsPerPageChange={(pageSize) => handleItemsPerPageChange(Number(pageSize))}
                settings={settings}
                handleFilterByKeyword={handleFilterByKeyword}
                extraTools={extraTools}
            />

            <MantineDataTable
                columns={columns as DataTableColumn[]}
                records={records}
                totalRecords={totalCount}
                recordsPerPage={limit}
                page={page}
                onPageChange={handlePageChange}
                paginationText={({
                                     from,
                                     to,
                                     totalRecords
                                 }) => `Records ${from} - ${to} of ${totalRecords}`}
                paginationSize={'md'}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={(items) => {
                    handleClearSelection();
                    (items as TestingAction[]).forEach(item => {
                        handleRowSelection(item.id, true);
                    });
                }}
                fetching={loading}
            />
        </Stack>
    );
};
